import React from 'react';
import PropTypes from 'prop-types';
import Icon from '../Icons/Icon';
import TextInput from '../Forms/TextInput';
import Button from '../Buttons/Button';
import BackButton from '../Buttons/BackButton';

const HeaderSearch = ({ searchTerm, onSearchTermChange, onSearchSubmit, searchLoading, onBackClick, inputRef }) => (
  <div className="header-search">
    <div className="header-search__mobile-back m-r-4 icon--m"><BackButton onClick={onBackClick} fill="white" /></div>

    <div className="header-search__form-container p-l-2 bg-black--dark border-1 border-color-black--light border-radius-l">
      <form className="header-search__form w-100 d-flex flex-grow-1">
        <TextInput
          name="search"
          value={searchTerm}
          placeholder="Search"
          onChange={onSearchTermChange}
          classes="d-flex flex-1 align-items-center m-b-0 m-r-2"
          inputClass="header-search__input faux-input p-a-0"
          inputRef={inputRef}
        />

        <Button type="submit" onClick={onSearchSubmit} classes="header-search__submit btn--input-submit btn--s" loading={searchLoading}>
          <Icon name="search" fill="white" classes="header-search__icon" />
        </Button>
      </form>
    </div>
  </div>
);

HeaderSearch.propTypes = {
  searchTerm: PropTypes.string.isRequired,
  onSearchTermChange: PropTypes.func.isRequired,
  onSearchSubmit: PropTypes.func.isRequired,
  searchLoading: PropTypes.bool.isRequired,
  onBackClick: PropTypes.func.isRequired,
  inputRef: PropTypes.func.isRequired,
};

export default HeaderSearch;



// WEBPACK FOOTER //
// ./library/app/components/Global/Header/HeaderSearch.js